import type { PostHog } from 'posthog-js';

export const safeStartSessionRecording = (posthog: PostHog | undefined) => {
  try {
    posthog?.startSessionRecording(true);
  } catch (err) {
    console.warn('PostHog startSessionRecording failed', err);
  }
};
